module.exports = __webpack_public_path__ + "img/x-kuchang-nan.67073f73.jpg";